import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
	selector: 'vb-lxp-race-flag-indicator',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './vb-lxp-race-flag-indicator.component.html',
	styleUrl: './vb-lxp-race-flag-indicator.component.css',
})
export class VbLxpRaceFlagIndicatorComponent {
	public raceStatus = input<any>(null);

	public shouldShow = computed(() => {
		const status = this.raceStatus();
		if (!status) return false;
		return !status.isClosed && status.currentFlag !== 'NONE';
	});

	public flagClass = computed(() => {
		const status = this.raceStatus();
		if (!status) return '';

		if (status.isFinished) return 'finish';
		if (status.currentFlag === 'RED') return 'red';
		if (status.currentFlag === 'FULL_YELLOW' || status.currentFlag === 'YELLOW') return 'yellow';
		if (status.currentFlag === 'GREEN') return 'green';
		if (status.currentFlag === 'CODE_60') return 'purple';
		return '';
	});

	public title = computed(() => {
		const status = this.raceStatus();
		if (!status) return 'Current Flag';
		if (status.isFinished) return 'Current Flag: Checkered';

		switch (status.currentFlag) {
			case 'RED':
				return 'Current Flag: Red';
			case 'FULL_YELLOW':
				return 'Current Flag: Full Yellow';
			case 'YELLOW':
				return 'Current Flag: Yellow';
			case 'GREEN':
				return 'Current Flag: Green';
			case 'CODE_60':
				return 'Current Flag: C60';
			default:
				return 'Current Flag';
		}
	});

	public label = computed(() => {
		const status = this.raceStatus();
		if (!status || status.isFinished) return '';

		if (status.currentFlag === 'RED') return 'RF';
		if (status.currentFlag === 'FULL_YELLOW' || status.currentFlag === 'YELLOW') return 'FCY';
		if (status.currentFlag === 'CODE_60') return 'C60';
		if (status.currentFlag === 'GREEN') return 'GF';
		return '';
	});
}